import { useState } from 'react';
import { toast } from 'sonner';
import { TrendingUp, Loader2, Search } from 'lucide-react';
import { round2 } from '../lib/api';

const rs = (n) => (n == null ? '—' : `₹${Number(n).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`);

export default function MandiPrices() {
  const [commodity, setCommodity] = useState('');
  const [state, setState] = useState('');
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);

  const search = async (e) => {
    e.preventDefault();
    if (!commodity.trim()) return toast.error('Type a crop or item, e.g. onion');
    setBusy(true);
    try { setRes(await round2.marketPrices(commodity.trim(), state.trim())); }
    catch (err) { toast.error(err?.response?.data?.detail || 'Could not fetch prices'); }
    finally { setBusy(false); }
  };

  return (
    <section data-testid="mandi-prices" className="card-soft p-5 mt-6 space-y-3">
      <div className="flex items-center gap-2 font-heading font-bold text-lg"><TrendingUp className="w-5 h-5 text-[#2E7D32]"/>Today's mandi prices</div>
      <form onSubmit={search} className="flex flex-wrap gap-2">
        <input data-testid="mandi-commodity-input" value={commodity} onChange={e => setCommodity(e.target.value)} placeholder="Crop / item (onion, wheat…)" className="flex-1 min-w-[160px] rounded-full border border-border px-4 py-2 text-sm"/>
        <input data-testid="mandi-state-input" value={state} onChange={e => setState(e.target.value)} placeholder="State (optional)" className="w-40 rounded-full border border-border px-4 py-2 text-sm"/>
        <button data-testid="mandi-search-btn" disabled={busy} className="btn-primary inline-flex items-center gap-1.5">
          {busy ? <Loader2 className="w-4 h-4 animate-spin"/> : <Search className="w-4 h-4"/>}Check prices
        </button>
      </form>
      {res && (
        <div data-testid="mandi-results" className="space-y-2">
          {res.summary && <p className="text-sm text-ink/80">{res.summary}</p>}
          {res.prices.length === 0 ? <p className="text-sm text-ink/60">No verified prices found today.</p> : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="text-left text-xs uppercase tracking-wider text-ink/60">
                  <tr><th className="p-2">Market</th><th className="p-2">Min</th><th className="p-2">Modal</th><th className="p-2">Max</th><th className="p-2">Date</th></tr>
                </thead>
                <tbody>
                  {res.prices.map((p, i) => (
                    <tr key={`${p.market}-${i}`} data-testid={`mandi-row-${i}`} className="border-t border-border">
                      <td className="p-2 font-semibold">{p.market}<div className="text-xs text-ink/50">{p.state}{p.variety ? ` · ${p.variety}` : ''}</div></td>
                      <td className="p-2">{rs(p.min_price)}</td><td className="p-2 font-bold">{rs(p.modal_price)}</td><td className="p-2">{rs(p.max_price)}</td>
                      <td className="p-2 text-xs">{p.price_date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <p className="text-xs text-ink/50 mt-1">Prices per quintal.</p>
            </div>
          )}
          {res.sources?.length > 0 && (
            <div className="text-xs text-ink/60">Sources: {res.sources.map((s, i) => <a key={s} href={s} target="_blank" rel="noreferrer" className="underline mr-2">[{i + 1}]</a>)}</div>
          )}
        </div>
      )}
    </section>
  );
}
